import { render, staticRenderFns } from "./createDeliveryOrderToInformView.vue?vue&type=template&id=77be3427&scoped=true"
import script from "./createDeliveryOrderToInformView.vue?vue&type=script&lang=js"
export * from "./createDeliveryOrderToInformView.vue?vue&type=script&lang=js"
import style0 from "./createDeliveryOrderToInformView.vue?vue&type=style&index=0&id=77be3427&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77be3427",
  null
  
)

export default component.exports